/**
 * Replay — record and play back deterministic matches.
 *
 * A recording is the seed plus the per-tick input map. Combined with the
 * deterministic Tick driver and the seeded Random, this is enough to replay
 * any match exactly. Stored as JSON in Storage by default.
 */
export class Replay {
  constructor() {
    this.seed = '';
    this.startedAtMs = 0;
    /** @type {Array<{s: number, inputs: object}>} */
    this.frames = [];
    this.recording = false;
    this.playing = false;
    this._playIndex = 0;
  }

  beginRecording(seed) {
    this.seed = seed;
    this.startedAtMs = Date.now();
    this.frames = [];
    this.recording = true;
    this.playing = false;
  }

  recordFrame(stepIndex, inputs) {
    if (!this.recording) return;
    this.frames.push({ s: stepIndex, inputs });
  }

  endRecording() {
    this.recording = false;
  }

  serialize() {
    return JSON.stringify({
      seed: this.seed,
      startedAtMs: this.startedAtMs,
      frames: this.frames
    });
  }

  static fromJSON(json) {
    const data = typeof json === 'string' ? JSON.parse(json) : json;
    const r = new Replay();
    r.seed = data.seed;
    r.startedAtMs = data.startedAtMs;
    r.frames = data.frames || [];
    return r;
  }

  beginPlayback() {
    this.playing = true;
    this._playIndex = 0;
  }

  /** Returns the inputs to apply at this step, or null if past the end. */
  inputsForStep(stepIndex) {
    if (!this.playing) return null;
    while (this._playIndex < this.frames.length && this.frames[this._playIndex].s < stepIndex) {
      this._playIndex += 1;
    }
    const f = this.frames[this._playIndex];
    if (f && f.s === stepIndex) return f.inputs;
    return {};
  }
}
